import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Layout from "./Layout"
import Home from "./pages/Home";
import Register from "./pages/Register";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./pages/PrivateRoute";
import UpdateProfile from "./pages/UpdateProfile";
import EmailLinkHandler from "./pages/EmailLinkHandler";
import ManageMember from "./pages/ManageMember";
import ManageRewards from "./pages/ManageRewards";
import TokenRecharge from "./pages/TokenRecharge";
import ReportingDashboard from "./pages/Report";
import MyVigor from "./pages/MyVigor";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={   <PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Home />} />
            <Route path="/add-member" element={<ManageMember />} />
            <Route path="/rewards" element={<ManageRewards />} />
            <Route path="/recharge" element={<TokenRecharge />} />
            <Route path="/report" element={<ReportingDashboard />} />
            <Route path="/updateProfile" element={<UpdateProfile />} />
            <Route path="/myVigor" element={<MyVigor />} />
          </Route>
          {/* if not logged in from the AuthContext  */}
          <Route path="register" element={<Register />} />  
          
          <Route path="/email-callback" element={<EmailLinkHandler />} />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
